import { useCallback, useEffect, useRef, useState } from 'react'

/** The Library's one-line confirmations ("Hid 2 files"), gone after a moment. */
export function useToast(ms = 2600) {
  const [text, setText] = useState('')
  const timer = useRef<number | undefined>(undefined)
  const say = useCallback(
    (next: string) => {
      window.clearTimeout(timer.current)
      setText(next)
      timer.current = window.setTimeout(() => setText(''), ms)
    },
    [ms],
  )
  useEffect(() => () => window.clearTimeout(timer.current), [])
  const node = text ? (
    <div className="lib-toast" role="status">
      {text}
    </div>
  ) : null
  return { say, node }
}
